export default __webpack_public_path__ + "media/images/users/user-mark-johnson-270x298-3a65ebcfc3668dc3a3aa67361121256a.jpg";